import { render, staticRenderFns } from "./IfDebug.vue?vue&type=template&id=25e9248b&scoped=true"
import script from "./IfDebug.vue?vue&type=script&lang=js"
export * from "./IfDebug.vue?vue&type=script&lang=js"
import style0 from "./IfDebug.vue?vue&type=style&index=0&id=25e9248b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e9248b",
  null
  
)

export default component.exports